export interface IAnimationDetailProps {
  animation: string;
  coreClass: string;
  reactVariable: string;
}
